import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'
import { fetchDispatch } from 'data/helpers'
import axios from 'axios'

export const JOBS_PER_PAGE = 10

// Backend enum mappings - must match server/Asclepius.Common/Jobs/*.cs
const PRACTICE_TYPE_MAP = {
  'FullTime': 1,
  'Full-Time': 1,
  'Locum': 2,
  'Telemedicine': 3,
  'PartTime': 4,
  'Part-Time': 4,
  'PRN': 5,
  'Travel': 6,
  'Contract': 2, // Map to Locum for now
}

const AREA_TYPE_MAP = {
  'Urban': 1,
  'Rural': 2,
  'Suburban': 3,
}

const ACADEMIC_TYPE_MAP = {
  'No': 1,
  'Yes': 2,
  'Hybrid': 3,
  'Academic': 2, // Map to Yes
  'Community': 1, // Map to No
  'Private Practice': 1, // Map to No
}

const SHIFT_TYPE_MAP = {
  'EightDay': 1,
  'EightAfternoon': 2,
  'EightOvernight': 3,
  'TwelveDay': 4,
  'TwelveNight': 5,
  'Mixed': 6,
  'Day': 1, // Map to EightDay
  'Night': 5, // Map to TwelveNight
  'Rotating': 6, // Map to Mixed
}

const SALARY_TYPE_MAP = {
  'Annual': 1,
  'Hourly': 2,
}

// Helper functions to map frontend values to backend enums
const mapPracticeType = (value) => {
  if (!value) return 1 // Default to FullTime if not specified
  return PRACTICE_TYPE_MAP[value] || 1 // Default to FullTime if mapping not found
}

const mapAreaType = (value) => {
  if (!value) return null
  return AREA_TYPE_MAP[value] || null
}

const mapAcademicType = (value) => {
  if (!value) return null
  return ACADEMIC_TYPE_MAP[value] || null
}

const mapShiftType = (value) => {
  if (!value) return null
  return SHIFT_TYPE_MAP[value] || null
}

const mapSalaryType = (value) => {
  if (!value) return null
  return SALARY_TYPE_MAP[value] || null
}

// mapJobData helper function - moved from legacy reducer
export const mapJobData = jobs =>
  (jobs || []).map(job => ({
    ...job,
    candidateTypeId: job.candidateType ? job.candidateType.id : null,
    listingTitle: job.title,
    listingSubLabel: job.employer.name,
    employerUserId: job.employerUser.id,
    specialtyId: job.specialties && job.specialties.length === 1 ? job.specialties[0].id : null,
    specialty: job.specialties && job.specialties.length === 1 ? job.specialties[0].name : null,
    subspecialtyId:
      job.subspecialties && job.subspecialties.length === 1 ? job.subspecialties[0].id : null,
    subspecialty:
      job.subspecialties && job.subspecialties.length === 1 ? job.subspecialties[0].name : null,
    area: job.areaType,
    academic: job.academicType,
    image: job.employer.image,
    firstName: job.user.firstName,
    lastName: job.user.lastName,
    visas: job.visas || [],
    employerName: job.employer.name,
    phone: job.user.phone,
    email: job.user.email,
    profileImage: job.user.profileImage,
    showPhone: job.user.showPhone,
    showEmail: job.user.showEmail,
    aboutEmployer: job.employer.about,
    shiftType: job.shiftType,
    salary: job.salary,
    salaryType: job.salaryType,
    salaryMin: job.salaryMin,
    salaryMax: job.salaryMax,
  }))

// Action Types - following your naming convention
export const GET_HOSPITAL_JOBS_LOADING = 'jobs/GET_HOSPITAL_JOBS_LOADING'
export const GET_HOSPITAL_JOBS_SUCCESS = 'jobs/GET_HOSPITAL_JOBS_SUCCESS'
export const GET_HOSPITAL_JOBS_FAILURE = 'jobs/GET_HOSPITAL_JOBS_FAILURE'

export const GET_CANDIDATE_JOBS_LOADING = 'jobs/GET_CANDIDATE_JOBS_LOADING'
export const GET_CANDIDATE_JOBS_SUCCESS = 'jobs/GET_CANDIDATE_JOBS_SUCCESS'
export const GET_CANDIDATE_JOBS_FAILURE = 'jobs/GET_CANDIDATE_JOBS_FAILURE'

export const GET_PUBLIC_JOBS_LOADING = 'jobs/GET_PUBLIC_JOBS_LOADING'
export const GET_PUBLIC_JOBS_SUCCESS = 'jobs/GET_PUBLIC_JOBS_SUCCESS'
export const GET_PUBLIC_JOBS_FAILURE = 'jobs/GET_PUBLIC_JOBS_FAILURE'

export const GET_SUPER_JOBS_LOADING = 'jobs/GET_SUPER_JOBS_LOADING'
export const GET_SUPER_JOBS_SUCCESS = 'jobs/GET_SUPER_JOBS_SUCCESS'
export const GET_SUPER_JOBS_FAILURE = 'jobs/GET_SUPER_JOBS_FAILURE'

export const ARCHIVE_JOB_LOADING = 'jobs/ARCHIVE_JOB_LOADING'
export const ARCHIVE_JOB_SUCCESS = 'jobs/ARCHIVE_JOB_SUCCESS'
export const ARCHIVE_JOB_FAILURE = 'jobs/ARCHIVE_JOB_FAILURE'

export const SET_SELECTED_FILTERS = 'jobs/SET_SELECTED_FILTERS'
export const SET_JOBS_UPDATED = 'jobs/SET_JOBS_UPDATED'

export const ADD_CANDIDATE_JOB_RATING_LOADING = 'jobs/ADD_CANDIDATE_JOB_RATING_LOADING'
export const ADD_CANDIDATE_JOB_RATING_SUCCESS = 'jobs/ADD_CANDIDATE_JOB_RATING_SUCCESS'
export const ADD_CANDIDATE_JOB_RATING_FAILURE = 'jobs/ADD_CANDIDATE_JOB_RATING_FAILURE'

export const UPDATE_CANDIDATE_JOB_RATING_LOADING = 'jobs/UPDATE_CANDIDATE_JOB_RATING_LOADING'
export const UPDATE_CANDIDATE_JOB_RATING_SUCCESS = 'jobs/UPDATE_CANDIDATE_JOB_RATING_SUCCESS'
export const UPDATE_CANDIDATE_JOB_RATING_FAILURE = 'jobs/UPDATE_CANDIDATE_JOB_RATING_FAILURE'

export const CREATE_BULK_JOBS_LOADING = 'jobs/CREATE_BULK_JOBS_LOADING'
export const CREATE_BULK_JOBS_SUCCESS = 'jobs/CREATE_BULK_JOBS_SUCCESS'
export const CREATE_BULK_JOBS_FAILURE = 'jobs/CREATE_BULK_JOBS_FAILURE'

// Action Creators - following your pattern
export const getHospitalJobsLoading = () => ({ type: GET_HOSPITAL_JOBS_LOADING })
export const getHospitalJobsSuccess = payload => ({ type: GET_HOSPITAL_JOBS_SUCCESS, payload })
export const getHospitalJobsFailure = payload => ({ type: GET_HOSPITAL_JOBS_FAILURE, payload })

export const getCandidateJobsLoading = () => ({ type: GET_CANDIDATE_JOBS_LOADING })
export const getCandidateJobsSuccess = payload => ({ type: GET_CANDIDATE_JOBS_SUCCESS, payload })
export const getCandidateJobsFailure = payload => ({ type: GET_CANDIDATE_JOBS_FAILURE, payload })

export const getPublicJobsLoading = () => ({ type: GET_PUBLIC_JOBS_LOADING })
export const getPublicJobsSuccess = payload => ({ type: GET_PUBLIC_JOBS_SUCCESS, payload })
export const getPublicJobsFailure = payload => ({ type: GET_PUBLIC_JOBS_FAILURE, payload })

export const getSuperJobsLoading = () => ({ type: GET_SUPER_JOBS_LOADING })
export const getSuperJobsSuccess = payload => ({ type: GET_SUPER_JOBS_SUCCESS, payload })
export const getSuperJobsFailure = payload => ({ type: GET_SUPER_JOBS_FAILURE, payload })

export const archiveJobLoading = () => ({ type: ARCHIVE_JOB_LOADING })
export const archiveJobSuccess = payload => ({ type: ARCHIVE_JOB_SUCCESS, payload })
export const archiveJobFailure = payload => ({ type: ARCHIVE_JOB_FAILURE, payload })

export const setSelectedFilters = (selectedFilters = []) => ({
  type: SET_SELECTED_FILTERS,
  payload: selectedFilters
})

export const setJobsUpdated = () => ({ type: SET_JOBS_UPDATED })

export const addCandidateJobRatingLoading = () => ({ type: ADD_CANDIDATE_JOB_RATING_LOADING })
export const addCandidateJobRatingSuccess = payload => ({ type: ADD_CANDIDATE_JOB_RATING_SUCCESS, payload })
export const addCandidateJobRatingFailure = payload => ({ type: ADD_CANDIDATE_JOB_RATING_FAILURE, payload })

export const updateCandidateJobRatingLoading = () => ({ type: UPDATE_CANDIDATE_JOB_RATING_LOADING })
export const updateCandidateJobRatingSuccess = payload => ({ type: UPDATE_CANDIDATE_JOB_RATING_SUCCESS, payload })
export const updateCandidateJobRatingFailure = payload => ({ type: UPDATE_CANDIDATE_JOB_RATING_FAILURE, payload })

export const createBulkJobsLoading = () => ({ type: CREATE_BULK_JOBS_LOADING })
export const createBulkJobsSuccess = payload => ({ type: CREATE_BULK_JOBS_SUCCESS, payload })
export const createBulkJobsFailure = payload => ({ type: CREATE_BULK_JOBS_FAILURE, payload })

// Async Actions - following your pattern exactly
export const fetchHospitalJobs = (searchParams) => {
  return async dispatch => {
    dispatch(getHospitalJobsLoading())
    try {
      const params = new URLSearchParams(searchParams)
      const response = await fetchDispatch({
        path: `/api/jobs/employer?${params.toString()}`,
        method: 'GET',
      })
      dispatch(getHospitalJobsSuccess(response))
      return response
    } catch (error) {
      dispatch(getHospitalJobsFailure(error.response || error.message))
      throw error
    }
  }
}

export const fetchCandidateJobs = (searchParams) => {
  return async dispatch => {
    dispatch(getCandidateJobsLoading())
    try {
      const params = new URLSearchParams(searchParams)
      const response = await fetchDispatch({
        path: `/api/jobs/candidate?${params.toString()}`,
        method: 'GET',
      })
      dispatch(getCandidateJobsSuccess(response))
      return response
    } catch (error) {
      dispatch(getCandidateJobsFailure(error.response || error.message))
      throw error
    }
  }
}

export const fetchPublicJobs = (searchParams) => {
  return async dispatch => {
    dispatch(getPublicJobsLoading())
    try {
      const params = new URLSearchParams(searchParams)
      const response = await fetchDispatch({
        path: `/api/jobs/public?${params.toString()}`,
        method: 'GET',
      })
      dispatch(getPublicJobsSuccess(response))
      return response
    } catch (error) {
      dispatch(getPublicJobsFailure(error.response || error.message))
      throw error
    }
  }
}

export const fetchSuperJobs = (searchParams) => {
  return async dispatch => {
    dispatch(getSuperJobsLoading())
    try {
      const params = new URLSearchParams(searchParams)
      const response = await fetchDispatch({
        path: `/api/jobs/super?${params.toString()}`,
        method: 'GET',
      })
      dispatch(getSuperJobsSuccess(response))
      return response
    } catch (error) {
      dispatch(getSuperJobsFailure(error.response || error.message))
      throw error
    }
  }
}

export const fetchArchiveJob = (requestVariables) => {
  return async dispatch => {
    dispatch(archiveJobLoading())
    try {
      await fetchDispatch({
        path: `/api/jobs/${requestVariables.id}`,
        method: 'PUT',
        values: requestVariables,
      })

      dispatch(archiveJobSuccess())

      // Handle success message
      const message = requestVariables.archive
        ? 'Successfully archived job.'
        : 'Successfully re-opened job.'
      dispatch(showSnackbar(message, snackbarTypes.SUCCESS))

      // Refresh jobs list
      dispatch(fetchHospitalJobs({ employerId: requestVariables.employerId }))

    } catch (error) {
      dispatch(archiveJobFailure(error.response || error.message))
      dispatch(showSnackbar(
        'Error Archiving this job, please try again later',
        snackbarTypes.ERROR,
      ))
      throw error
    }
  }
}

export const fetchAddCandidateJobRating = (values) => {
  return async dispatch => {
    dispatch(addCandidateJobRatingLoading())
    try {
      await axios({
        url: 'api/jobs/rating',
        method: 'POST',
        data: { ...values },
      })
      dispatch(addCandidateJobRatingSuccess())
      dispatch(showSnackbar(
        'Thank you for rating! This will help other Stethi users!',
        snackbarTypes.SUCCESS,
      ))
    } catch (error) {
      dispatch(addCandidateJobRatingFailure(error.response?.data))
      dispatch(showSnackbar(
        'Error rating this job, please try again later.',
        snackbarTypes.ERROR
      ))
      throw error
    }
  }
}

export const fetchUpdateCandidateJobRating = (values) => {
  return async dispatch => {
    dispatch(updateCandidateJobRatingLoading())
    try {
      await axios({
        url: `api/jobs/rating/${values.id}`,
        method: 'PUT',
        data: {
          candidateId: values.candidateId,
          jobId: values.jobId,
          rating: values.rating,
          comment: values.comment,
        },
      })
      dispatch(updateCandidateJobRatingSuccess())
      dispatch(showSnackbar(
        'Thank you for updating this job rating! This will help other Stethi users!',
        snackbarTypes.SUCCESS,
      ))
    } catch (error) {
      dispatch(updateCandidateJobRatingFailure(error.response?.data))
      dispatch(showSnackbar(
        'Error rating this job, please try again later.',
        snackbarTypes.ERROR
      ))
      throw error
    }
  }
}

export const fetchCreateBulkJobs = ({ jobs, urls, employerId, employerUserId }) => {
  return async dispatch => {
    dispatch(createBulkJobsLoading())
    try {
      // Transform jobs to match backend expectations
      const transformedJobs = jobs.map(job => ({
        employerUserId: employerUserId,
        title: job.title,
        city: job.city,
        state: job.state,
        areaType: mapAreaType(job.area), // Map frontend 'area' to backend enum
        practiceType: mapPracticeType(job.practiceType), // Map to enum value
        salary: job.salary,
        specialtyNames: job.specialtyIds ? job.specialtyIds.map(() => {
          // For now, we'll use the specialty names directly if available
          // You may need to adjust this based on your data structure
          return job.specialty || null
        }).filter(Boolean) : [],
        subspecialtyNames: job.subspecialtyIds ? job.subspecialtyIds.map(() => {
          return job.subspecialty || null
        }).filter(Boolean) : [],
        link: job.link,
        pslfCompatible: job.pslfCompatible === 'Yes' || job.pslfCompatible === true,
        loanForgiveness: job.loanForgiveness === 'Yes' || job.loanForgiveness === true,
        academicType: mapAcademicType(job.academicType), // Map to enum value
        about: job.about,
        aboutRaw: job.aboutRaw,
        aboutHtml: job.aboutHtml,
        visas: job.visaIds ? job.visaIds.join(',') : '', // Adjust based on your visa handling
        candidateTypeId: job.candidateTypeId || 1, // Default to 1 if not specified
        shiftType: mapShiftType(job.shiftType), // Map to enum value
        salaryMin: job.salaryMin,
        salaryMax: job.salaryMax,
        salaryType: mapSalaryType(job.salaryType), // Map to enum value
        count: job.count || 1 // Default to 1 if not specified
      }))

      const response = await fetchDispatch({
        path: '/api/jobs/bulk',
        method: 'POST',
        values: {
          jobs: transformedJobs,
          sourceUrls: urls
        }
      })

      dispatch(createBulkJobsSuccess(response))

      // Show success/error messages based on results
      if (response.hasErrors) {
        dispatch(showSnackbar(
          `Uploaded ${response.successfulJobs}/${response.totalJobs} jobs. ${response.failedJobs} failed.`,
          snackbarTypes.WARNING
        ))
      } else {
        dispatch(showSnackbar(
          `Successfully uploaded ${response.successfulJobs} job${response.successfulJobs !== 1 ? 's' : ''}!`,
          snackbarTypes.SUCCESS
        ))
      }

      // Refresh the jobs list to show the new jobs
      if (employerId) {
        dispatch(fetchHospitalJobs({ employerId }))
      }

      return response
    } catch (error) {
      dispatch(createBulkJobsFailure(error.response || error.message))
      dispatch(showSnackbar(
        'Error uploading jobs. Please try again.',
        snackbarTypes.ERROR
      ))
      throw error
    }
  }
}
const initialState = {
  jobsList: [],
  selectedFilters: [],
  isLoadingJobs: false,
  jobsUpdated: false,
  totalJobs: 0,
  page: 1,
  pageSize: JOBS_PER_PAGE,
  candidateMatchCounts: {},
  error: null
}

export function jobsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_HOSPITAL_JOBS_LOADING:
      return { ...state, isLoadingJobs: true, error: null }
    case GET_HOSPITAL_JOBS_SUCCESS: {
      const matchCountsMap = {}
      if (action.payload.candidateMatchCounts) {
        for (const counts of action.payload.candidateMatchCounts) {
          matchCountsMap[counts.jobId] = {
            excellent: counts.excellentCount,
            strong: counts.strongCount,
            good: counts.goodCount,
            total: counts.totalCount,
          }
        }
      }
      return {
        ...state,
        jobsList: mapJobData(action.payload.jobs),
        totalJobs: action.payload.totalCount,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        candidateMatchCounts: matchCountsMap,
        isLoadingJobs: false,
        error: null
      }
    }
    case GET_HOSPITAL_JOBS_FAILURE:
      return { ...state, isLoadingJobs: false, error: action.payload }

    case GET_CANDIDATE_JOBS_LOADING:
    case GET_PUBLIC_JOBS_LOADING:
    case GET_SUPER_JOBS_LOADING:
      return { ...state, isLoadingJobs: true, jobsUpdated: false, error: null }
    case GET_CANDIDATE_JOBS_SUCCESS:
    case GET_PUBLIC_JOBS_SUCCESS:
    case GET_SUPER_JOBS_SUCCESS:
      return {
        ...state,
        jobsList: mapJobData(action.payload.jobs),
        totalJobs: action.payload.totalCount,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        isLoadingJobs: false,
        error: null
      }
    case GET_CANDIDATE_JOBS_FAILURE:
    case GET_PUBLIC_JOBS_FAILURE:
    case GET_SUPER_JOBS_FAILURE:
      return { ...state, isLoadingJobs: false, error: action.payload }

    case ARCHIVE_JOB_LOADING:
      return { ...state, isLoadingJobs: true }
    case ARCHIVE_JOB_SUCCESS:
      return { ...state, isLoadingJobs: false }
    case ARCHIVE_JOB_FAILURE:
      return { ...state, isLoadingJobs: false, error: action.payload }

    case SET_SELECTED_FILTERS:
      return { ...state, selectedFilters: action.payload }

    case SET_JOBS_UPDATED:
      return { ...state, jobsUpdated: true }

    case ADD_CANDIDATE_JOB_RATING_LOADING:
      return { ...state, jobsUpdated: false }
    case ADD_CANDIDATE_JOB_RATING_SUCCESS:
      return { ...state, jobsUpdated: true }
    case ADD_CANDIDATE_JOB_RATING_FAILURE:
      return { ...state, jobsUpdated: false }

    case UPDATE_CANDIDATE_JOB_RATING_LOADING:
      return { ...state, jobsUpdated: false }
    case UPDATE_CANDIDATE_JOB_RATING_SUCCESS:
      return { ...state, jobsUpdated: true }
    case UPDATE_CANDIDATE_JOB_RATING_FAILURE:
      return { ...state, jobsUpdated: false }

    case CREATE_BULK_JOBS_LOADING:
      return { ...state, isLoadingJobs: true }
    case CREATE_BULK_JOBS_SUCCESS:
      return { ...state, isLoadingJobs: false }
    case CREATE_BULK_JOBS_FAILURE:
      return { ...state, isLoadingJobs: false, error: action.payload }
    default:
      return state
  }
}
